import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../pages/Home/homeSlice";
import searchReducer from "../pages/Search/searchSlice";
import propertyReducer from "../pages/Property/propertySlice";
export default configureStore({
    reducer: {
        search: searchReducer,
        property: propertyReducer,
        home: homeReducer,
    },
});
